/**
 * API Service
 *
 * Binds the generated HTTP functions to the configured Axios client.
 * All endpoint functions are auto-generated from the AsyncAPI spec.
 * Infrastructure (interceptors, auth, error recovery) lives in apiClient.ts.
 */

import { apiClient, resetSyncRecovery } from './apiClient';
import { bindClient } from '../generated/api/api-client';

export const api = {
  ...bindClient(apiClient),
  resetSyncRecovery,
};
